export default {
  EPBPA_CARD_IDLE: 'idle_helmet_card',
  EPBPA_CARD_BUY: 'buy_helmet_card',
  EPBPA_BUY_BUTTON_SIDE: 'buy_button_side',
  EPBPA_TITLE_IDLE: 'title_idle',
  EPBPA_TITLE_START: 'title_start',
};
